module.exports = __webpack_public_path__ + "img/u156.7bc9bd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/figma/u156.png
// module id = U+Bw
// module chunks = 0